<template>
  <!--  <router-link-modified v-if="isLogged"-->
  <!--                        :to="{name: 'legal-services-request-sent'}"-->
  <!--                        class="base-btn base-btn&#45;&#45;blue">-->
  <!--    <span class="base-btn__text">{{ $tLegalServices('Get help') }}</span>-->
  <!--    <BaseSvg name="ico-arrow-light"/>-->
  <!--  </router-link-modified>-->
  <!--  <router-link-modified v-else-->
  <!--                        :to="{name: 'auth', query: {'for-legal': 'true', redirect}}"-->
  <!--                        class="base-btn base-btn&#45;&#45;blue">-->
  <!--    <span class="base-btn__text">{{ $tLegalServices('Get help') }}</span>-->
  <!--    <BaseSvg name="ico-arrow-light"/>-->
  <!--  </router-link-modified>-->

  <button @click.prevent="onClick"
          class="base-btn base-btn--blue">
    <span class="base-btn__text">{{ $tLegalServices('Get help') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </button>
</template>

<script>
  export default {
    name: 'LegalServicesPageGetHelpBtn',
    props: {
      botUrls: Object
    },
    computed: {
      // isLogged() {
      //   return this.$store.getters['user/isLogged']
      // },
      // redirect() {
      //   const lang = this.$route.params.lang
      //   let name = 'legal-services-request-sent'
      //
      //   if (
      //     (!lang || lang === 'ua')
      //   ) {
      //     name += '-double'
      //   }
      //   const route = this.$router.matcher.match({name, params: {lang}})
      //   return route.fullPath
      // }
    },
    methods: {
      onClick() {
        this.$vModal.open('open-legal-services-chat-bot', {
          botUrls: this.botUrls
        })
      }
    }
  }
</script>

<style lang="less">

</style>
